const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Gamepad {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'gamepadExt', name: '🕹️ ゲームパッド', color1: '#8B5CF6', color2: '#7C3AED',
            blocks: [
                { opcode: 'connected', blockType: BlockType.BOOLEAN, text: 'ゲームパッドが接続されている？' },
                { opcode: 'button', blockType: BlockType.BOOLEAN, text: 'ボタン [B] が押されている？', arguments: { B: { type: ArgumentType.NUMBER, defaultValue: 0 } } },
                { opcode: 'axis', blockType: BlockType.REPORTER, text: '軸 [A] の値', arguments: { A: { type: ArgumentType.NUMBER, defaultValue: 0 } } },
                { opcode: 'leftX', blockType: BlockType.REPORTER, text: '左スティックX' },
                { opcode: 'leftY', blockType: BlockType.REPORTER, text: '左スティックY' },
                { opcode: 'rightX', blockType: BlockType.REPORTER, text: '右スティックX' },
                { opcode: 'rightY', blockType: BlockType.REPORTER, text: '右スティックY' }
            ]
        };
    }
    _gp() { var gps = navigator.getGamepads ? navigator.getGamepads() : []; for (var i = 0; i < gps.length; i++) if (gps[i]) return gps[i]; return null; }
    connected() { return this._gp() !== null; }
    button(args) { var gp = this._gp(); return gp && gp.buttons[Cast.toNumber(args.B)] ? gp.buttons[Cast.toNumber(args.B)].pressed : false; }
    axis(args) { var gp = this._gp(); return gp ? gp.axes[Cast.toNumber(args.A)] || 0 : 0; }
    leftX() { return this.axis({ A: 0 }); }
    leftY() { return this.axis({ A: 1 }); }
    rightX() { return this.axis({ A: 2 }); }
    rightY() { return this.axis({ A: 3 }); }
}
module.exports = Scratch3Gamepad;